import { Component, Input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { EVENTS } from '@constants/analytics';
import { AnalyticsService } from '@services/analytics.service';

@Component({
	standalone: false,
	selector: 'qe-embedded-video',
	templateUrl: './embedded-video.component.html',
	styleUrls: ['./embedded-video.component.scss']
})
export class EmbeddedVideoComponent {
	@Input() public readonly videoUrl?: string | undefined = '';
	@Input() public readonly platform?: string = '';
	public isPlaying: boolean = false;
	public embedUrl?: SafeResourceUrl | null = null;

	constructor(
		private readonly gtmService: AnalyticsService,
		private readonly sanitizer: DomSanitizer
	) {
	}

	public safeVideoUrl(): SafeResourceUrl | null {
		return this.videoUrl ? this.sanitizer.bypassSecurityTrustResourceUrl(this.videoUrl) : null;
	}

	public handleClickPlay(): void {
		this.embedUrl = this.safeVideoUrl();
		this.isPlaying = true;

		this.gtmService.push({
			event: EVENTS.CLICK,
			click_location: 'embedded-video',
			click_text: 'image-video-placeholder',
			click_type: 'play-video',
			click_id: `embedded-video-${this.videoUrl}`
		});
	}
}
